"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Apr 25 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemUpdateDTOConverter.
 *
 * @author BPo
 */


var WindowUpdateDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowUpdateDTOConverter, _DataObjectConverter_);

  function WindowUpdateDTOConverter() {
    _classCallCheck(this, WindowUpdateDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowUpdateDTOConverter).apply(this, arguments));
  }

  return WindowUpdateDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowUpdateDTOConverter = WindowUpdateDTOConverter;